module.exports = __webpack_public_path__ + "img/kara.bdfe5adc.png";